import { ShippingInfoEditPanel } from "./ShippingInfoEditPanel";

export function AddressChangeModal({ shippingInfo, onClose, onSave }) {
  return (
    <div className="address-change-modal" role="dialog" aria-modal="true" aria-label="배송정보 수정">
      <button className="address-change-dim" type="button" aria-label="닫기" onClick={onClose} />
      <ShippingInfoEditPanel shippingInfo={shippingInfo} onClose={onClose} onSave={onSave} />
    </div>
  );
}
